// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"362":"488deeb6","499":"ff832aee","562":"9c1e83e7"}[chunkId] + ".chunk.css";
};